import { DrawableLine } from './Drawable/DrawableLine';

export class Wall extends DrawableLine {}
